import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Landings extends Component {
  state = {
    landings: [],
    loading: true,
  };

  componentDidMount() {
    this.fetchLandings();
  }

  fetchLandings = async () => {
    try {
      const res = await axios.get("/landings");
      if (res.data.status === "success") {
        this.setState({ landings: res.data.data, loading: false });
      } else {
        this.setState({ loading: false });
        Swal.fire("Error", res.data.message || "Failed to fetch landings", "error");
      }
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
      Swal.fire("Error", "Failed to fetch landings", "error");
    }
  };

  previewLanding = (id) => {
    const base_url = axios.defaults.baseURL.replace("/api", "");
    const url = `${base_url}/api/landing/view/${id}`;
    window.open(url, "_blank");
  };

  handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the landing page.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await axios.delete(`/landings/${id}`);
      if (res.data.status === "success") {
        Swal.fire("Deleted!", res.data.message, "success");
        this.fetchLandings();
      } else {
        Swal.fire("Error", res.data.message || "Delete failed", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to delete landing", "error");
    }
  };

  cloneLanding = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to clone this landing page?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, clone it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await axios.post(`/landing/clone/${id}`);

      if (res.data.status === "success") {
        Swal.fire("Success", "Landing cloned successfully", "success");
        this.fetchLandings();
      } else {
        Swal.fire("Error", res.data.message || "Clone failed", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Clone failed", "error");
    }
  };


  render() {

    const { landings, loading } = this.state;
    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="card shadow-none">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Landing Pages</h5>
              <Link to="/admin/landing_form" className="btn btn-light-warning btn-sm">New Landing</Link>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-striped mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Image</th>
                      <th>Product</th>
                      <th>Title</th>
                      <th>Page URL</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={7} className="text-center">Loading...</td>
                      </tr>
                    ) : landings.length === 0 ? (
                      <tr>
                        <td colSpan={7} className="text-center">No landings found</td>
                      </tr>
                    ) : (
                      landings.map((l, idx) => (
                        <tr key={l.id}>
                          <td>{idx + 1}</td>
                          <td>
                            {l.product_img ? (
                              <img
                                src={`${baseUrl}/uploads/products/${l.product_img}`}
                                alt="img"
                                style={{ width: "50px", height: "50px", borderRadius: "6px" }}
                              />
                            ) : (
                              "No Image"
                            )}
                          </td>
                          <td>{l.product_name || "—"}</td>
                          <td>{l.title || "—"}</td>
                          <td>{l.page_url || "—"}</td>
                          <td>{String(l.public_status) === "1" ? "Active" : "Inactive"}</td>
                          <td>

                            <Link title="Landing Edit"
                              to={`/admin/landing/edit/${l.id}`}
                              className="btn btn-sm btn-light-success me-1">
                              <i className="ph ph-note-pencil align-middle"></i>
                            </Link>

                            <button title="Webpage View"
                              className="btn btn-sm btn-light-warning"
                              onClick={() => this.previewLanding(l.id)}>
                              <i className="ph ph-globe align-middle"></i>
                            </button>

                            <Link title="Webpage Builder" target="_blank"
                              to={`/admin/landing/page/builder/${l.id}`}
                              className="btn btn-sm btn-light-primary me-1">
                              <i className="ph ph-textbox align-middle"></i>
                            </Link>

                            <Link title="Landing Clone"
                              onClick={() => this.cloneLanding(l.id)}
                              className="btn btn-sm btn-light-primary me-1">
                              <i className="ph ph-copy align-middle"></i>
                            </Link>

                            <button
                              className="btn btn-sm btn-light-danger"
                              onClick={() => this.handleDelete(l.id)}>
                              <i className="ph ph-trash align-middle"></i>
                            </button>

                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Landings;
